export function createStaticDataActions(
  set: any,
  _get: () => unknown
) {
  return {
    setStaticData: (data: Record<string, any>) => {
      set({ staticData: data }, false, "map/setStaticData");
    },

    setLoadingStaticData: (isLoading: boolean) => {
      set(
        { isLoadingStaticData: isLoading },
        false,
        "map/setLoadingStaticData"
      );
    },
  };
}

